import { Box } from '@mui/material';
import React from 'react';

const BotChatIcon = () => {
   return (
      <Box sx={{ minWidth: '32px', minHeight: '32px' }}>
         <svg width={32} height={32} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16' fill='#F0CAC9' />
            <path
               d='M24.774 14.479c-.376-.707-.862-1.238-1.481-1.636l-3.227-2.099h-.022c-.685-.442-1.458-.663-2.298-.685V8.004a.58.58 0 0 0-.243-.464l-3.227-2.1c-.11-.088-.265-.11-.42-.088l-3.8.773c-.266.044-.443.287-.443.553v16.884c0 .176.11.353.265.464l3.227 2.1a.5.5 0 0 0 .31.088h.11l3.713-.752a.59.59 0 0 0 .42-.398c2.033.62 4.375-.42 5.745-1.922 2.144-2.299 2.719-5.945 1.37-8.663'
               fill='#252626'
            />
            <path
               d='M21.062 12.645c.442.818.663 1.768.663 2.895s-.22 2.21-.663 3.183a7.3 7.3 0 0 1-1.834 2.475 5.8 5.8 0 0 1-2.718 1.304c-1.039.199-1.282.11-1.857-.045a4 4 0 0 1-.75-.331v.663l-3.713.751V6.656l3.8-.773v6.077a5.24 5.24 0 0 1 2.542-1.26c1.017-.198 1.945-.132 2.718.2.796.353 1.392.928 1.834 1.723zm-3.447 4.928c.177-.375.243-.795.243-1.237s-.088-.796-.243-1.127c-.177-.31-.398-.53-.73-.663-.309-.133-.684-.155-1.104-.089-.42.067-.752.243-1.061.509-.31.265-.553.574-.707.95-.177.376-.243.796-.243 1.238s.088.84.265 1.149q.266.464.729.663c.31.132.663.176 1.06.088a2.5 2.5 0 0 0 1.084-.53 2.9 2.9 0 0 0 .729-.973'
               fill='#fff'
            />
         </svg>
      </Box>
   );
};

export default BotChatIcon;
